import { createFileRoute } from "@tanstack/react-router";
import { CTABand } from "@/components/site/CTABand";
import { PhoneButton } from "@/components/site/PhoneButton";

export const Route = createFileRoute("/coupons")({
  head: () => ({
    meta: [
      { title: "Plumbing Coupons Phoenix | Seasonal Deals" },
      { name: "description", content: "Save on plumbing repairs in Phoenix. $25 off any repair plus seasonal water heater and drain specials. Call 602-834-1208." },
      { property: "og:title", content: "Plumbing Coupons Phoenix | Seasonal Deals" },
      { property: "og:description", content: "Save on plumbing repairs in Phoenix. $25 off any repair plus seasonal water heater and drain specials. Call 602-834-1208." },
      { property: "og:url", content: "https://www.phoenixplumbing.co/coupons" },
      { name: "twitter:title", content: "Plumbing Coupons Phoenix | Seasonal Deals" },
      { name: "twitter:description", content: "Save on plumbing repairs in Phoenix. $25 off any repair plus seasonal water heater and drain specials. Call 602-834-1208." },
    ],
    links: [{ rel: "canonical", href: "https://www.phoenixplumbing.co/coupons" }],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <section className="bg-secondary text-secondary-foreground">
        <div className="mx-auto max-w-4xl px-4 py-14">
          <h1 className="text-4xl md:text-5xl font-extrabold">Plumbing Coupons Phoenix</h1>
          <p className="mt-4 text-secondary-foreground/85 text-lg">Save on plumbing repairs in Phoenix. $25 off any repair plus seasonal water heater and drain specials. Call 602-834-1208.</p>
          <div className="mt-6"><PhoneButton size="lg" /></div>
        </div>
      </section>
      <article className="mx-auto max-w-3xl px-4 py-12 prose prose-lg">
        <h2>$25 off any repair</h2><p>Mention this page when you call. Limit one per household.</p><h2>$50 off any water heater install</h2><p>Tank or tankless — any brand.</p><h2>Free camera inspection</h2><p>With any main-line drain cleaning over $350.</p>
      </article>
      <CTABand />
    </>
  );
}
